import { useGetGolfEventSummaryQuery } from '../state/api';
import { selectEventsBySeries } from '../state/entitySelectors';
import { useAppSelector } from '../hooks/reduxHooks';
import TourEventNavigator from './tour-event-navigator';

const TourEventNavigatorContainer = () => {
  // Fetch data with RTK Query
  useGetGolfEventSummaryQuery();

  // Use entity selector with built-in series filter (memoized, no useMemo needed!)
  const tourEvents = useAppSelector((state) => selectEventsBySeries(state, 'Summer Tour'));

  return <TourEventNavigator tourEvents={tourEvents} />;
};

export default TourEventNavigatorContainer;
